"use client";

import type { SupSingleVaultV3 } from "@/types";
import React, { MouseEvent, useMemo } from "react";

import { useStoredData, useStoredDataDispatch } from "@/store/Context";
import { SupIconButton, SupStar2 } from "@repo/core-ui";

interface PropsGridCellToggleFavorite {
  singleVault: SupSingleVaultV3;
}
export default function GridCellToggleFavorite({ singleVault }: PropsGridCellToggleFavorite) {
  const storedData = useStoredData();
  const storedDispatch = useStoredDataDispatch();

  const isFavorite = useMemo(() => storedData.favorites.includes(singleVault.slug), [singleVault.slug, storedData.favorites]);

  return (
    <SupIconButton
      activeClassName="fill-primary-900"
      active={isFavorite}
      className="group"
      onClickCapture={(event: MouseEvent) => {
        event.stopPropagation();
        storedDispatch({ type: "toggleFavorites", vault: singleVault });
        return false;
      }}
    >
      <SupStar2 className="h-6 w-6 group-hover:scale-125" />
    </SupIconButton>
  );
}
